export default async (): Promise<void> => {
    await nextTick();

    const firstError = document.querySelector('[aria-invalid="true"]');
    firstError?.parentElement?.parentElement?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
};
